<template>
  <div :contenteditable="editable"
    ref="content-input"
    @blur.stop="handleBlur"
    @keydown.enter="handleEnter"
  >
    {{ inputData }}
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      inputData: this.content
    }
  },
  watch: {
    content (val) {
      this.inputData = val
    }
  },
  methods: {
    handleBlur (event) {
      this.$emit('change', event.target.innerText)
    },
    handleEnter (event) {
      event.target.blur()
      return false
    }
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/schemaFonctionnel/ui/editableUI.vue